/**
 * Present when the user scrolls inside the scroll area.
 */
export const scrolling = 'data-scrolling';
/**
 * Present when the scroll area content is wider than the viewport.
 */
export const hasOverflowX = 'data-has-overflow-x';
/**
 * Present when the scroll area content is taller than the viewport.
 */
export const hasOverflowY = 'data-has-overflow-y';
/**
 * Present when there is overflow on the horizontal start side.
 */
export const overflowXStart = 'data-overflow-x-start';
/**
 * Present when there is overflow on the horizontal end side.
 */
export const overflowXEnd = 'data-overflow-x-end';
/**
 * Present when there is overflow on the vertical start side.
 */
export const overflowYStart = 'data-overflow-y-start';
/**
 * Present when there is overflow on the vertical end side.
 */
export const overflowYEnd = 'data-overflow-y-end';
